import { Component, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { copyToClipboard } from '../../utils/clipboard';

/**
 * How a drone owner connects a DJI drone to ADN (ADN-2307). The authorization
 * itself happens on DJI's own platform, not here, so this is guidance only.
 * The steps follow DJI's "Agras Drone Data Authorization Guidelines".
 */
@Component({
  selector: 'app-dji-authorization-guide',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dji-authorization-guide.component.html'
})
export class DjiAuthorizationGuideComponent implements OnDestroy {
  /** ADN's Regulatory Authority email. Blank until configured for the environment. */
  readonly authorityEmail: string = environment.djiRegulatoryAuthorityEmail;
  readonly supportPhone: string = environment.technicalSupportPhone;

  readonly copied = signal(false);
  private copiedTimer: ReturnType<typeof setTimeout> | null = null;

  async copyEmail(): Promise<void> {
    if (!this.authorityEmail) return;
    const ok = await copyToClipboard(this.authorityEmail);
    this.copied.set(ok);
    this.clearCopiedTimer();
    if (ok) {
      this.copiedTimer = setTimeout(() => this.copied.set(false), 2000);
    }
  }

  ngOnDestroy(): void {
    this.clearCopiedTimer();
  }

  private clearCopiedTimer(): void {
    if (this.copiedTimer) {
      clearTimeout(this.copiedTimer);
      this.copiedTimer = null;
    }
  }
}
